/**CORE LIBRARIES IMPORT */
import React from "react";

/**HOOKS IMPORT */
import useInViewOnce from "../hooks/useInViewOnce";

/**
 * The template's `.section-heading` (Michroma + animated purple→blue double
 * underline), with the same IntersectionObserver trigger the template used.
 */
const SectionHeading = ({ title, id, as: Tag = "h2", className = "" }) => {
  const [ref, inView] = useInViewOnce(0.5);

  return (
    <Tag id={id} ref={ref} className={`section-heading ${inView ? "in-view" : ""} ${className}`}>
      {title}
    </Tag>
  );
};

export default SectionHeading;
